import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bs-container sazka-toast__container" }
const _hoisted_2 = { class: "sazka-toast__inner sazka-toast__inner--left" }

import { ref, watch, onMounted } from "vue";
import { useNgSession } from "@sazka/ng/ng-session";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { GamingLimitsDto } from "./model/gaming-limits";
import { useSessionStorage } from "@sazka/utils/use-storage";
import { isFullAccount } from "@sazka/player/player-account";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { useRgLimitsPopup } from "@/shared/components/rg-limits/use-rg-limits-popup";
import { RgFrom } from "@/shared/components/rg-limits/analytics/analytics-rg-limits";
import { RgLimitsAnalytics } from "./analytics/analytics-rg-limits";
import { usePopupsSequence } from "@/shared/components/master-page/use-popups-sequence";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";

const storageName = "rg-limits-bar";

interface LimitsBar {
    text: string;
    showtime: number;
}

const REQUIRED_TIME = 5_000;
const NON_REQUIRED_TIME = 5_000;
const COMPENSATION_FOR_RELOAD_TIME = 2_000;
const CLOSING_ANIMATION_TIME = 400;


export default /*@__PURE__*/_defineComponent({
  __name: 'rg-limits-bar',
  setup(__props) {

const showBar = ref(false);
const showCloseButton = ref(false);
const isSlidingUp = ref(false);
const isSlidingDown = ref(false);
const barText = ref("");
let requiredTimeTimeout = null;
let nonRequiredTimeTimeout = null;

const { isLoggedIn } = useNgSession();

const storage = useSessionStorage();
const { isRgLimitsBarVisible, isRgLimitsBarClosed, isLegalWarningVisible } = usePopupsSequence();

const getBarText = (limits: GamingLimitsDto) => {
    const limitValues = [
        limits.lossDaily.currentAmount,
        limits.lossMonthly.currentAmount,
        limits.loginCount.currentAmount,
        limits.loginDuration.currentAmount,
        limits.coolOffTime.currentAmount,
        limits.spendingDaily.currentAmount,
        limits.spendingMonthly.currentAmount,
    ];
    if (limitValues.every((l) => l)) {
        return "Máte nastaveny sebeomezující opatření, jejich nastavení můžete změnit";
    }

    if (limitValues.some((l) => l)) {
        return "Máte nastavena pouze některá sebeomezující opatření, jejich nastavení můžete upravit";
    }

    return "Nemáte nastaveny sebeomezující opatření, můžete si je nastavit";
};

const closeBar = () => {
    isSlidingDown.value = true;
    storage.removeItem(storageName);
    clearTimeout(requiredTimeTimeout);
    clearTimeout(nonRequiredTimeTimeout);
    setTimeout(() => {
        isRgLimitsBarClosed.value = true;
        isSlidingDown.value = false;
        showCloseButton.value = false;
    }, CLOSING_ANIMATION_TIME);
};

const openRgLimits = async () => {
    const { showRgPopup } = useRgLimitsPopup();
    RgLimitsAnalytics.pushClickRgLimitsBar(barText.value + " ZDE.");
    await showRgPopup(RgFrom.loginBar);
    closeBar();
};

const startNonRequiredShowTime = () => {
    showCloseButton.value = true;
    storage.removeItem(storageName);
    nonRequiredTimeTimeout = setTimeout(() => {
        closeBar();
    }, NON_REQUIRED_TIME);
};

const openBar = () => {
    isSlidingUp.value = true;
    showBar.value = true;
    storage.setJson<LimitsBar>(storageName, { showtime: Date.now(), text: barText.value }, "essential");

    requiredTimeTimeout = setTimeout(() => {
        startNonRequiredShowTime();
    }, REQUIRED_TIME);
};

const checkForOpenBar = () => {
    const bar = storage.getJson<LimitsBar>(storageName);
    if (!bar) {
        return;
    }

    barText.value = bar.text;
    showBar.value = true;

    const seenMiliseconds = Date.now() - Number(bar.showtime);

    requiredTimeTimeout = setTimeout(() => {
        startNonRequiredShowTime();
    }, REQUIRED_TIME - seenMiliseconds + COMPENSATION_FOR_RELOAD_TIME);
};

checkForOpenBar();

watch(isFullAccount, async (value) => {
    if (value) {
        try {
            isRgLimitsBarVisible.value = !isLegalWarningVisible.value;
            const response = await httpClient.get<GamingLimitsDto>("/api/gaming-limits");
            barText.value = getBarText(response.data);
            openBar();
            RgLimitsAnalytics.pushShowRgLimitsBar(barText.value + " ZDE.");
        } catch {
            isRgLimitsBarClosed.value = true;
        }
    }
});

onMounted(async () => {
    await ngFrameworkLoaded();
    watch(isLoggedIn, (value) => {
        if (!value) {
            closeBar();
        } else {
            isRgLimitsBarVisible.value = !isLegalWarningVisible.value;
        }
    });
});

return (_ctx: any,_cache: any) => {
  return (showBar.value && _unref(isRgLimitsBarVisible))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['sazka-toast sazka-toast--bottom', { hiding: isSlidingDown.value }, { active: isSlidingUp.value }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(barText.value) + " ", 1),
            _createElementVNode("a", {
              class: "sazka-toast__link",
              onClick: openRgLimits
            }, "ZDE"),
            _cache[0] || (_cache[0] = _createTextVNode(". "))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["sazka-toast__close sazka-toast__close--bottom", { 'sazka-toast__close--bottom-active': showCloseButton.value }]),
            onClick: closeBar,
            "aria-label": "Zavřít notifikaci"
          }, [
            _createVNode(DsIcon, {
              name: "close",
              width: 16,
              height: 16
            })
          ], 2)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})